import {Component, ViewChild} from "@angular/core";
import {IAuthenticationService} from "../../../../domain/server/IAuthenticationService";
import {NavigationService} from "../../../navigation/NavigationService";
import {ErrorPopupComponent} from "../../generic/popup/errorPopup/errorPopup";

@Component({
    styleUrls: ['./mainPage.scss'],
    templateUrl: './mainPage.html'
})
export class AdminMainPageComponent {

    @ViewChild(ErrorPopupComponent) errorPopupComponent:ErrorPopupComponent;

    private authenticationService:IAuthenticationService;
    private navigationService:NavigationService;
    public password:string;

    constructor(authenticationService: IAuthenticationService, navigationService: NavigationService) {
        this.authenticationService = authenticationService;
        this.navigationService = navigationService;
    }

    public login(){
        this.authenticationService.Authenticate(this.password).then(() => {
            this.navigationService.Navigate('/admin/occasions')
        }).catch(err => {
            this.errorPopupComponent.Open("Problème d'autentification", "Mot de passe incorrect");
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/mainPage/mainPage.ts